import { getApiClient } from './ApiClient'

// Read plus one write. Creating, editing and rescheduling a schedule is a db/data patch, not an
// admin action (API-1004): a `job.name` only does anything if the deployed code exports a matching
// handler in src/job/index.js, so the row and its handler have to ship in the same release.
//
// Taking one out of service and putting it back are the exception, because that is an incident
// action that cannot wait for a deploy. One endpoint in both directions: two would mean two
// permission codes, and an admin granted one and not the other gets a page that can stop a
// production job and not start it again.
export const jobListPromise = () => {
  return getApiClient()
    .get('/jobs')
    .then(resp => resp.data)
}

export const jobSetActivePromise = (id, active) => {
  return getApiClient()
    .post(`/jobs/${id}/active`, { body: { active } })
    .then(resp => resp.data)
}
